import React from 'react';

export const IconStreamsCharts = ({
  size = 16,
  className,
}: {
  size?: number;
  className?: string;
}) => {
  return (
    <svg
      className={className}
      xmlns="http://www.w3.org/2000/svg"
      width={size}
      height={size}
      viewBox="0 0 16 16"
      fill="none"
    >
      <g clip-path="url(#clip0_674_52)">
        <mask
          id="mask0_674_52"
          style={{maskType: 'luminance'}}
          maskUnits="userSpaceOnUse"
          x="0"
          y="0"
          width="16"
          height="16"
        >
          <path d="M15.9836 0H0V15.984H15.9836V0Z" fill="white" />
        </mask>
        <g mask="url(#mask0_674_52)">
          <path
            d="M13.9171 9.00018H11.357L9.88561 7.52882L6.11439 11.2999L3.81456 9.00018H0L2.08296 7.00022H4.64298L6.11439 8.47158L9.88561 4.70047L12.1854 7.00022H16L14.9585 8.0002L13.9171 9.00018Z"
            fill="#6EC4FF"
          />
          <path
            d="M7.99995 16C12.4182 16 15.9999 12.4184 15.9999 8.00023V7.00024H13.917V9.00021C13.4409 11.8378 10.9729 14 7.99995 14C6.34281 14 4.84418 13.3296 3.7573 12.2428L3.0502 11.5357L1.63599 12.9498L2.34309 13.6569C3.78971 15.1035 5.79109 16 7.99995 16Z"
            fill="url(#paint0_linear_674_52)"
          />
          <path
            d="M8 -9.15527e-05C3.58172 -9.15527e-05 0 3.58153 0 7.99967L0 8.99966H2.04148L2.08296 6.99973C2.55904 4.1621 5.02702 1.99985 8 1.99985C9.65714 1.99985 11.1558 2.67031 12.2426 3.75718L12.9497 4.46427L14.364 3.05008L13.6568 2.34299C12.2102 0.896409 10.2089 -9.19126e-05 8 -9.15527e-05Z"
            fill="url(#paint1_linear_674_52)"
          />
        </g>
      </g>
      <defs>
        <linearGradient
          id="paint0_linear_674_52"
          x1="0.0116642"
          y1="15.9996"
          x2="16.0112"
          y2="-0.000433117"
          gradientUnits="userSpaceOnUse"
        >
          <stop stop-color="#FF498B" />
          <stop offset="0.146105" stop-color="#FF498B" />
          <stop offset="0.337674" stop-color="#9A4BE3" />
          <stop offset="0.425982" stop-color="#7B4CFF" />
          <stop offset="0.573373" stop-color="#7191FF" />
          <stop offset="0.661458" stop-color="#6EC4FF" />
          <stop offset="0.853082" stop-color="#6EC4FF" />
          <stop offset="1" stop-color="#6EC4FF" />
        </linearGradient>
        <linearGradient
          id="paint1_linear_674_52"
          x1="15.9883"
          y1="0.000342828"
          x2="-0.0112841"
          y2="16.0003"
          gradientUnits="userSpaceOnUse"
        >
          <stop stop-color="#FF498B" />
          <stop offset="0.146105" stop-color="#FF498B" />
          <stop offset="0.337674" stop-color="#9A4BE3" />
          <stop offset="0.425982" stop-color="#7B4CFF" />
          <stop offset="0.573373" stop-color="#7191FF" />
          <stop offset="0.661458" stop-color="#6EC4FF" />
          <stop offset="0.853082" stop-color="#6EC4FF" />
          <stop offset="1" stop-color="#6EC4FF" />
        </linearGradient>
        <clipPath id="clip0_674_52">
          <rect width="16" height="16" fill="white" />
        </clipPath>
      </defs>
    </svg>
  );
};
